import API_BASE_URL from '../Config';

export const getProfesiones = async (token) => {
    const response = await fetch(`${API_BASE_URL}/profesiones`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error('Error al cargar profesiones');
    return response.json();
};

export const getProfesionesPaginadas = async (token, page = 0, size = 10, search = '') => {
    const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
        search: search
    });

    const response = await fetch(`${API_BASE_URL}/profesiones/page?${params.toString()}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error('Error al cargar profesiones paginadas');
    return response.json();
};

export const getProfesionById = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/profesiones/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error('Error al cargar la profesión');
    return response.json();
};

export const createProfesion = async (token, profesionData) => {
    const response = await fetch(`${API_BASE_URL}/profesiones`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(profesionData)
    });
    if (!response.ok) throw new Error('Error al crear profesión');
    return response.json();
};

export const updateProfesion = async (token, id, profesionData) => {
    const response = await fetch(`${API_BASE_URL}/profesiones/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(profesionData)
    });
    if (!response.ok) throw new Error('Error al actualizar profesión');
    return response.json();
};

export const deleteProfesion = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/profesiones/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error('Error al desactivar profesión');
    return response.json();
};
